var base = require('settings/security/update-password');

Vue.component('spark-update-password', {
    mixins: [base],
    data() {
        return {
            pw_hidden: true,
            npw_hidden: true,
            cpw_hidden: true
        };
    }
});
